import PropTypes from 'prop-types';

export const DESKTOP = 'desktop';
export const TABLET = 'tablet';
export const MOBILE = 'mobile';
export const INFINITY = DESKTOP;

// FYI - redux-responsive defaults
// const defaultBreakpoints = {
//   extraSmall: 480,
//   small: 768,
//   medium: 992,
//   large: 1200,
// };

export const BREAKPOINTS = {
  [MOBILE]: 728,
  [TABLET]: 1024,
  [DESKTOP]: 1200,
};

export const PROP_TYPES = {
  mediaType: PropTypes.string.isRequired,
  is: PropTypes.shape({
    [MOBILE]: PropTypes.bool,
    [TABLET]: PropTypes.bool,
    [DESKTOP]: PropTypes.bool,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/store/actions/browser.types.js